import { render, staticRenderFns } from "./SectionGameHistory.vue?vue&type=template&id=13973482&"
import script from "./SectionGameHistory.vue?vue&type=script&lang=js&"
export * from "./SectionGameHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports